import { useNavigate } from 'react-router-dom';
import './styles.css';
import { useEffect, useState } from 'react';
import useValidateSession from '../../hooks/useValidateSession';
import useGetSession from '../../hooks/useGetSession';
import useTypeSession from '../../hooks/useTypeSession';

export default function Home() {
  const navigate = useNavigate();
  const [session, setSession] = useState<string | null>(null);
  const isValidSession = useValidateSession();
  const sessionData = useGetSession();
  const sessionType = useTypeSession();
  
  useEffect(() => {
    console.log(isValidSession);
    
    if (isValidSession === null) return; // Aguarda resposta da API

    if (isValidSession === false) {
        console.log("Redirecionando para página de erro...");
        window.location.href = process.env.REACT_APP_REDIRECT_URL || "https://app.banclima.org.br";
        return;
    }

    if (sessionData !== undefined) {
        setSession(sessionData || '');
    }
}, [isValidSession]);
  

  return (
    <div className='background-container'>
      <div className='main-container'>
        <img src={process.env.PUBLIC_URL + '/icon512.png'} alt='Logo' width={300} height={42}></img>
        <main className='content'>
          <h1>Olá, bem-vindo(a) ao ID One!</h1>
          <p>Neste site você poderá enviar seus documentos de identificação e selfie para validação do nosso sistema</p>

          <button
            className='btn-init'
            type='button'
            onClick={() => navigate(`/selfie?session=${encodeURIComponent(session || '')}&type=${encodeURIComponent(sessionType || '')}`, {
              state: { session, sessionType }
            })}
          >
            Iniciar
          </button>
        </main>
      </div>
    </div>
    
  );
}
